<template>
	<div>
		<breadcrumb :routerList="[{to:'/pricenew',title:'特价管理'},{to:'/pricenew',title:'特价列表'},{title:'查看详情'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowCon">
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>客户信息</h1>
								</div>
								<div class="h-pieceCon2">
									<div class="h-formLine weekplandetail">
										<el-form :model="shangbuneirong" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
										  <el-form-item label="客户名称" class="h-elformWrap-2" prop="formCon4">
											<el-input v-model="shangbuneirong.kehumingcheng" placeholder="客户名称" disabled="disabled"></el-input>
										  </el-form-item>
                                          <el-form-item label="审批时间" class="h-elformWrap-2" prop="formCon5">
											<el-input v-model="shangbuneirong.shenpishijian" placeholder="审批时间" disabled="disabled"></el-input>
										  </el-form-item>
                                          <el-form-item label="开始时间" class="h-elformWrap-2" prop="formCon6">
											<el-input v-model="shangbuneirong.kaishishijian" placeholder="开始时间" disabled="disabled"></el-input>
										  </el-form-item>
                                          <el-form-item label="截止时间" class="h-elformWrap-2" prop="formCon7">
											<el-input v-model="shangbuneirong.jiezhishijian" placeholder="截止时间" disabled="disabled"></el-input>
										  </el-form-item>
										  <el-form-item label="产品型号" class="h-elformWrap-2" prop="formCon8">
											<el-input v-model="shangbuneirong.chanpinxinghao" placeholder="" disabled="disabled"></el-input>
										  </el-form-item>
										  <el-form-item label="产品数量" class="h-elformWrap-2" prop="formCon9">
											<el-input v-model="shangbuneirong.chanpinshuliang" placeholder="产品数量" disabled="disabled"></el-input>
										  </el-form-item>
										</el-form>
									</div>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>数据图表</h1>
								</div>
								<div class="h-pieceCon2">
									<div class="flexBox">
										<div class="flex">
											<div class="h-pieChart" id="h_lineChart1" style="width: 100%; height: 100%;"></div>
										</div>
										<div class="flex">
											<div class="h-pieChart" id="h_lineChart2" style="width: 100%; height: 100%;"></div>
										</div>
									</div>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>关联特价订单列表</h1>
								</div>
								<div>
									<el-table
										ref="multipleTable"
										@selection-change="handleSelectionChange"
										:data="tableData2"
										stripe
										border
										max-height="450"
										style="width: 100%"
										>
<!--										<el-table-column-->
<!--												type="selection"-->
<!--												width="55"-->
<!--												label="全选"-->
<!--										>-->
<!--										</el-table-column>-->
										<el-table-column
											type="index"
											label="#"
											width="40">
										</el-table-column>
										<el-table-column
											prop="reporter"
											label="订单编号"
											:show-overflow-tooltip="true">
										</el-table-column>
										<el-table-column
											prop="visitTime"
											label="型号"
											:show-overflow-tooltip="true">
											<template slot-scope="scope">
												<div style="text-align: left;">
													{{scope.row.visitTime}}
												</div>
											</template>
										</el-table-column>
										<el-table-column
											prop="num"
											label="数量">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.num}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
											prop="price"
											label="标准价格">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.price}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
											prop="grade"
											label="特价价格">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.grade}}
													</div>
												</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-tableB h-mrt30">
				<div></div>
				<div class="h-pagination2">
					<pagination :page="q" @query="query" />
				</div>
			</div>
			<div style="display:flex;justify-content: center;margin-top: 0.7rem;width: 100%;">
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="fanhuishangyiye" >返回</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import ss from '../../../api/SystemService'
const cityOptions = [1,2,3,4,5,6,7,8];
export default {
	data(){
      return{
		  q: {
			  pageSize: 10,
			  pageNo: 1,
			  total:0,
		  },
		  //特价版本id
		  idmsg:'',
		  //关联特价订单列表内容
		  xiangqinglist:[],
		  //关联特价订单列表内容视图操作批次id
		  xiangqingshituid:'',
		  //特价列表视图
		  specialview:{},
		  //标准价总额
		  biaozhunjiagezonge:'',
		  //折扣价总额
		  zhekoujiazonge:'',
		  //优惠金额总额
		  youhuijiagezonge:'',
		  //使用量进度
		  shiyongjindu:[],
		  //带线表单
			formLabelAlign: {
				formCon4: '',
				formCon5: '',
				formCon6:'',
				formCon7:'',
				formCon8:'',
				formCon9:'',
		   },
			shangbuneirong:{
				kehumingcheng:'',
				shenpishijian:'',
				kaishishijian:'',
				jiezhishijian:'',
				chanpinxinghao:'',
				chanpinshuliang:'',
			},
			multipleSelection: [],
			tableData2: [],
            offer:{
                category:'',
            },
		}
    },
   methods:{
		fanhuishangyiye(){
			this.$router.back();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
      lineChart1(){
			let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
			let option = {
				title : {
					text: '使用情况',
					subtext: '剩余可用/总数量:  '+this.specialview.useing,
					bottom:'0',
					left:'23%',
					textVerticalAlign:'center'
				},
				tooltip : {
					trigger: 'item',
					formatter: "{a} <br/>{b} : {c} ({d}%)"
				},
				legend: {
					orient: 'vertical',
					right: 100,
					top:100,
					data: ['已使用','未使用']
				},
				series : [
					{
						name: '使用情况',
						type: 'pie',
						radius : '47%',
						center: ['30%', '35%'],
						data:[
								{value:this.shiyongjindu[2], name:'已使用',selected:true},
								{value:this.shiyongjindu[0]==null||this.shiyongjindu[0]==''||this.shiyongjindu[0]=='0'?'1':this.shiyongjindu[0], name:'未使用'}
						],
						itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								},
								color:function(params) {
								//自定义颜色
								var colorList = [
									'#afe6fd', '#16b7fa'
								];
								return colorList[params.dataIndex]
								}
						}
					}
				]
			};
			lineChart1.setOption(option);
      },
        	lineChart2(){
				let lineChart2 = this.$echarts.init(document.getElementById('h_lineChart2'));
				let option = {
					title : {
						text: '优惠总额',
						subtext: this.youhuijiagezonge+'元',
						bottom:'0',
						left:'23%',
						textVerticalAlign:'center'
					},
					tooltip : {
						trigger: 'item',
						formatter: "{a} <br/>{b} : {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						right:100,
						top:100,
						data: ['优惠额度','实付金额']
					},
					series : [
						{
							name: '优惠总额',
							type: 'pie',
							radius : '47%',
							center: ['30%', '35%'],
							data:[
									{value:this.youhuijiagezonge, name:'优惠额度',selected:true},
									{value:this.zhekoujiazonge==null||this.zhekoujiazonge==''||this.zhekoujiazonge=='0.0'?'1':this.zhekoujiazonge, name:'实付金额'}
							],

							hoverOffset:10,
							itemStyle: {
									emphasis: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									},
									color:function(params) {
									//自定义颜色
									var colorList = [
										'#afe6fd', '#16b7fa'
									];
									return colorList[params.dataIndex]
									}
							}
						}
					]
				};
			lineChart2.setOption(option);
		},
		//查询翻页
		query() {
            console.log(this.q, "下面表格参数");
            console.log(this.offer.category, "cate");
            if (this.offer.category == '13') {
                ss.tejiaVw.specialorderviewselectPageCG(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.gettableels(rd.records);
                    console.log(rd.records, "下面表格数据");
                })
            } else {
                ss.tejiaVw.specialorderviewselectPage(this.q).then(rd => {
                    console.log(this.q,'qq')
                    console.log(rd, "下面表格");
                    this.q.total = rd.total;
                    this.gettableels(rd.records);
                    console.log(rd.records, "下面表格数据");
                })
            }
		},
		//检索
		handleFilter() {
			this.q.pageNo = 1;
			this.query();
		},
		//接收前页转发的特价列表视图id
		getParams(){
			//拿到特价产品id
			this.idmsg = this.$route.query.id;
			this.q.specialId=this.idmsg;

			console.log("idmsg",this.idmsg)
			var id ={
				dtid: this.idmsg,
			}
			//取页面参数
			ss.specialController.tejiaxiangqing(id).then(rd => {
				//上部标头内容
				this.specialview = rd.specialview;
				//标准价格总价
				this.biaozhunjiagezonge = rd.biaozhunjiagezonge;
				//折扣价格总价
				this.zhekoujiazonge = rd.zhekoujiazonge;
				//优惠总金额
				this.youhuijiagezonge = rd.youhuijiagezonge;
				//使用进度数组
				this.shiyongjindu = rd.shiyongjindu;
				console.log(this.specialview,'loook')
				console.log(this.biaozhunjiagezonge)
				console.log(this.zhekoujiazonge)
				console.log(this.youhuijiagezonge)
				console.log(this.shiyongjindu)
				this.shangbuneirong.kehumingcheng = rd.specialview.username;
				this.shangbuneirong.shenpishijian = rd.specialview.checkdate;
				this.shangbuneirong.kaishishijian = rd.specialview.startdate;
				this.shangbuneirong.jiezhishijian = rd.specialview.enddate;
				this.shangbuneirong.chanpinxinghao = rd.specialview.materialDescrition;
				this.shangbuneirong.chanpinshuliang = rd.specialview.useing;
				//画图
				this.lineChart1();
				this.lineChart2();

				this.offer = rd.offer;
				this.query();
			})
		},
		//加载表格
		gettableels(q){
			this.tableData2 = [];

			//若有数据
			if(q){

				this.xiangqinglist = q;
				for(var c in q){
					var table = {
						reporter: q[c].dingdanbianhao,
						visitTime: q[c].chanpinxinghao,
						num: q[c].chanpinshuliang,
						price: q[c].biaozhunjiage,
						grade: q[c].tejiajiage,
					}

					console.log(table,'tabletabletable')

					this.tableData2.push(table)
				}

			}


		},
   },
	created() {//在模板编译进路由前调用created方法，触发接收函数
		this.getParams();
	},
	mounted(){

	}
}
</script>

<style scoped>
.downLond{
    height: 33px;
    line-height: 33px;
    margin: 10px;
    display: flex;
    font-size: 0.2rem;
}
.downLond .texts{
    margin-left: 20px;
    color: #0964ae;
    text-decoration: underline;
    cursor: pointer;
}
.downLond .yulan{
    color: #727272;
    cursor: pointer;
    margin-left: 20px;
}
.downLond .down{
    color: #0964ae;
    cursor: pointer;
    text-decoration: underline;
    margin-left: 20px;
}
.flexBox{
    width: 100%;
    height: 300px;
    display: flex;
}
.flexBox .flex{
    width: 50%;
}
.weekplandetail{
    margin-top: 0.38rem;
}
</style>
<style>
.weekplandetail .h-formbLine .el-form-item__label{
    width: 34%;
    text-align: right;
}
.weekplandetail .h-formbLine .el-form-item__content{
    width: 66%;
}
.weekplandetail .h-formbLine .h-elformWrap-2{
    width: 33.333%;
	 padding-right: 0.5rem

}
.weekplandetail .h-formbLine .h-elformWrap-1{
    width: 100%;
    padding-right: 0.5rem
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label{
    width: 9.7%;
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content{
    width: 90.3%;
}
</style>
